const getNumEncodings = async (publisher) => {
  if (!publisher) {
    return 0;
  }
  const [sender] = await publisher._getVideoSenders();
  if (!sender) {
    return 0;
  }
  const { encodings } = sender.getParameters();
  return Array.isArray(encodings) ? encodings.length : 0;
};

export default getNumEncodings;
